import React, { Component } from 'react';
import { IImageProps, IImageState } from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import ImageComponent from '@kurtosys/ksys-app-components/dist/components/base/Image';

@inject('appStore', 'imageStore')
@observer
export class Image extends Component<IImageProps, IImageState> {
	static configurationKey: 'image' = 'image';
	static styleKey: 'image' = 'image';
	constructor(props: IImageProps) {
		super(props);
	}
	render() {
		const { className, imageStore } = this.props;

		if (!imageStore) {
			return null;
		}

		const { imageProps } = imageStore;

		if (imageProps && imageProps.src) {
			const imageError = (imageElement: HTMLImageElement) => {
				imageElement.src = 'data:image/svg+xml,<svg height="0" width="0" xmlns="http://www.w3.org/2000/svg"/>';
				imageElement.style.display = 'none';
			};
			const errorHandler = (e: any) => {
				imageError(e.target);
			};
			return (
				<Wrapper data-selector="fund-manager-image-wrapper" className={ className }>
					<ImageComponent { ...imageProps } onError={ errorHandler } />
					<ImageComponent asset={ 'management.fundManager.placeholder' } onError={ errorHandler } />
				</Wrapper>
			);
		}

		return null;
	}
}

export default InjectedStyledComponent(Image, 'image');
